import React from 'react'

import { Card, CardContent, Typography, makeStyles } from '@material-ui/core'

import { CardHeaderColor } from 'components/Card'
import helpers from 'helpers'
import styles from './styles'

const useStyles = makeStyles(styles)

const ClientDetail = ({ customer }) => {
  const classes = useStyles()

  const Detail = () => (
    <>
      <CardHeaderColor color="secondary" title="CLIENTE SELECIONADO" />
      <CardContent>
        <div className={classes.detailContainer}>
          <div className={classes.detailHeader}>
            {helpers.people.isCompany(customer.kind) ? (
              <>
                <Typography variant="h3" className={classes.name}>
                  {customer.tradeName}
                </Typography>
                <Typography className={classes.text}>
                  CNPJ {helpers.people.formatCnpj(customer.cnpj)}
                </Typography>
              </>
            ) : (
              <>
                <Typography variant="h3" className={classes.name}>
                  {customer.name}
                </Typography>
                <Typography className={classes.text}>
                  CPF {helpers.people.formatCpf(customer.cpf)}
                </Typography>
              </>
            )}
          </div>
          <div className={classes.detailBody}>
            <Typography className={classes.text}>
              Email: {customer.email}
            </Typography>
            <Typography className={classes.text}>
              Telefone: {helpers.people.parsePhoneApi(customer.contact)}
            </Typography>
            <Typography className={classes.text}>
              Endereço: {customer.address.street}, {customer.address.number} -{' '}
              {customer.address.neighborhood} - {customer.address.city}/
              {customer.address.state} -{' '}
              {helpers.people.formatCep(customer.address.postalCode)}
            </Typography>
          </div>
        </div>
      </CardContent>
    </>
  )

  const NotFound = () => (
    <CardContent className={classes.notSelectedContainer}>
      <div>
        <Typography variant="h3" className={classes.notSelectedTitle}>
          Nenhum cliente selecionado
        </Typography>
        <Typography className={classes.notSelectedSubTitle}>
          Selecione um cliente na listagem ao lado para visualizar os dados
          completos
        </Typography>
      </div>
    </CardContent>
  )

  return (
    <Card className={classes.root}>{customer ? <Detail /> : <NotFound />}</Card>
  )
}

export default ClientDetail
